import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_Collapse = _resolveComponent("Collapse")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Collapse, {
      class: "tabs-collapse",
      open: $props.tabs.length > 1
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Tabs, {
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
          class: "assistant-tabs",
          tabs: $props.tabs,
          bordered: $props.bordered,
          disabled: $props.disabled
        }, null, 8 /* PROPS */, ["modelValue", "tabs", "bordered", "disabled"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"]),
    _createElementVNode("div", {
      class: _normalizeClass(["tabs-content", {leave: $data.leave}]),
      relative: ""
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.$slots), (slot) => {
        return (_openBlock(), _createBlock(_Transition, {
          key: slot,
          onEnter: $options.onBeforeEnter,
          onBeforeLeave: $options.onBeforeLeave,
          onAfterEnter: $options.onAfterEnter
        }, {
          default: _withCtx(() => [
            (_ctx.value === slot)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref_for: true,
                  ref: "items",
                  class: "item"
                }, [
                  _renderSlot(_ctx.$slots, slot, {}, undefined, true)
                ])), [
                  [_directive_resize, () => !$data.leave && $data.on_resize()]
                ])
              : _createCommentVNode("v-if", true)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onEnter", "onBeforeLeave", "onAfterEnter"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}